import { Decode, Utils } from '@/composables/utils';
import { routes } from './routes';
import store from '@/store';
import { createRouter, createWebHistory } from 'vue-router';
import { PERMISSION2 } from '@/composables/type';
import AccountService from '@/service/AccountService';

const router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = Utils.getSessionStorage('token');
  // const token = store.getters['authority/token'];

  if (token) {
    const isAdmin = Decode.getDecode().permission == PERMISSION2.ADMIN.KEY;
    const passPath = ['/timetable/current', '/timetable/manage'];

    if (!isAdmin && passPath.includes(to.path)) {
      await router.replace('/404');
      return;
    }

    // 로그인 화면은 OTP 미인증 토큰일 수 있으므로 제외 (프로필은 enterDashboard에서 설정)
    if (to.path !== '/login' && !store.getters['profile/profile']) {
      await AccountService.setProfile().catch(() => {});
    }
  }

  if (to.path !== '/login' && token === null) {
    await router.replace('/login');
  } else {
    next();
  }
});

export default router;
